import { extendTheme } from "@chakra-ui/react";
import { createBreakpoints } from "@chakra-ui/theme-tools";

const breakpoints = createBreakpoints({
  sm: "30em",
  md: "48em",
  lg: "62em",
  xl: "80em",
  "2xl": "1024px",
  "3xl": "1280px",
  "4xl": "1366px",
  "5xl": "1440px",
  "6xl": "1680px",
  "7xl": "1920px",
});

const theme = extendTheme({
  breakpoints,
  styles: {
    global: {
      "html, body, #__next": {
        h: "100%",
      },
      body: {
        fontFamily: "Helvetica",
        color: "primary",
      },
    },
  },
  colors: {
    primary: "#2D4FA7",
    secondary: "#F9A70D",
    black: "#2B2B2B",
    gray: "#777777",
    sky: "#F0F3F7",
    blue: "#102542",
    white: "#ffffff",
    red: "#ff0000",
  },
  textStyles: {
    buttonText: {
      fontSize: ["0.75rem", null, null, null, null, "1.125rem"],
      fontWeight: "700",
      lineHeight: ["1rem", null, null, null, null, "1.75rem"],
      letterSpacing: ["0.33px", null, null, null, null, "0.5px"],
      textDecoration: "none",
    },
    paragraph: {
      fontSize: ["0.75rem", null, null, null, null, "1.5rem"],
      fontWeight: "400",
      lineHeight: ["1.25rem", null, null, null, null, "1.875rem"],
      color: "gray",
    },
    paragraphHighlighted: {
      fontSize: ["1rem", null, null, null, null, "1.5rem"],
      fontWeight: "400",
      lineHeight: ["1.5625rem", null, null, null, null, "1.875rem"],
      color: "main",
    },
    navLink: {
      fontSize: "1rem",
      lineHeight: "1.5rem",
    },
    h1: {
      fontSize: ["2.25rem", null, null, null, null, "3.5rem", "4.5rem"],
      fontWeight: "700",
      lineHeight: ["2.7rem", null, null, null, null, "5.4rem"],
    },
    h2: {
      fontSize: ["1.125rem", null, null, null, null, "2.875rem"],
      fontWeight: "300",
      lineHeight: ["1.35rem", null, null, null, null, "3.45rem"],
    },
  },
  components: {
    Button: {
      baseStyle: {
        color: "white",
      },
      variants: {
        base: {
          bgColor: "primary",
          minHeight: ["32px", null, null, null, null, "54px"],
          height: ["32px", null, null, null, null, "54px"],
        },
        outline: {
          bgColor: "white",
          borderColor: "primary",
          borderWidth: "2px",
          minHeight: ["32px", null, null, null, null, "54px"],
          height: ["32px", null, null, null, null, "54px"],
        },
      },
      defaultProps: {
        variant: "base",
      },
    },
    Input: {
      variants: {
        base: {
          field: {
            bgColor: "sky",
            borderRadius: 0,
            height: ["22px", null, null, null, null, "44px"],
          },
        },
      },
      defaultProps: {
        variant: "base",
      },
    },
    Textarea: {
      baseStyle: {
        resize: "none",
        minHeight: ["182px", null, null, null, null, "294px"],
      },
      variants: {
        base: {
          bgColor: "sky",
          borderRadius: 0,
          height: "44px",
        },
      },
      defaultProps: {
        variant: "base",
      },
    },
  },
});

export default theme;
